<template>
  <div class="expansion-channel-wrapper">
    <detail-section title="已加入通道">
      <btn-style :btn-list="btnList" class="btn-list-style"></btn-style>
      <normal-table
        ref="commonTable"
        class="channel-table"
        :table-col="tableCol"
        :table-data="chanList"
        :operator="operator"
        :operate-col="operateCol"
        :show-edit="true"
        :paging="chanPaging"
        @pagination="handleSizeOrPageChange"
      >
      </normal-table>
    </detail-section>
    <el-divider></el-divider>
    <detail-section title="交易记录">
      <normal-table
        ref="commonTable"
        class="tx-table"
        :table-col="txTableCol"
        :table-data="txList"
        :paging="txPaging"
        @pagination="handleTxSizeOrPageChange"
      >
      </normal-table>
    </detail-section>
    <create-channel ref="createChannel" :user-id="userId" @createChannelSuccess="getList"></create-channel>
    <join-channel ref="joinChannel" :user-id="userId" @joinChannelSuccess="getList"></join-channel>
    <exit-channel ref="exitChannel" :user-id="userId" @exitChannelSuccess="getList"> </exit-channel>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

import createChannel from './components/createChannel' //创建通道
import joinChannel from './components/joinChannel' //创建通道
import exitChannel from './components/exitChannel' //退出

export default {
  name: 'ChannelPage',
  components: {
    createChannel,
    joinChannel,
    exitChannel
  },
  props: {
    userId: {
      type: Number,
      default: 0
    },
    chainId: {
      type: String,
      default: () => ''
    }
  },
  data() {
    return {
      btnList: [
        {
          btnContent: '加入通道',
          click: () => {
            return this.joinChannel()
          },
          icon: 'icon-import'
        },
        {
          btnContent: '创建通道',
          click: () => {
            return this.createdChannel()
          },
          icon: 'icon-add'
        }
      ],
      // 设置table的列
      tableCol: [
        {
          prop: 'chanId',
          label: '扩容通道ID',
          minWidth: 215
        },
        {
          prop: 'chanName',
          label: '扩容通道名称',
          minWidth: 242
        },
        {
          prop: 'balance',
          label: '余额',
          formatter: row => {
            return `￥${row.balance}`
          },
          minWidth: 216
        },
        {
          prop: 'createAt',
          label: '创建时间',
          formatter: row => {
            return this.formatTime(row)
          },
          minWidth: 278
        }
      ],
      operator: [
        {
          text: '进入通道',
          click: (row, col, cellValue) => {
            return this.goChannel(row)
          },
          icon: 'icon-check',
          showText: true
        },
        {
          text: '退出通道',
          click: (row, col, cellValue) => {
            return this.exitChannel(row)
          },
          icon: 'icon-cancel',
          showText: true
        }
      ],
      operateCol: {
        minWidth: 216
      },
      txTableCol: [
        {
          prop: 'chanName',
          label: '通道名称',
          minWidth: 195
        },
        {
          prop: 'txId',
          label: '交易哈希',
          minWidth: 326
        },
        {
          prop: 'fromUserName',
          label: '交易发起方',
          minWidth: 194
        },
        {
          prop: 'toUserName',
          label: '交易接收方',
          minWidth: 194
        },
        {
          prop: 'balance',
          label: '交易金额',
          minWidth: 132,
          formatter: row => {
            return `￥${row.balance}`
          }
        },
        {
          prop: 'createAt',
          label: '交易时间',
          formatter: row => {
            return this.formatTime(row)
          },
          minWidth: 126
        }
      ]
    }
  },
  computed: {
    ...mapState({
      chanList: state => state.expansionDemo.chan_list,
      chanPaging: state => state.expansionDemo.chan_paging,
      txList: state => state.expansionDemo.tx_list,
      txPaging: state => state.expansionDemo.tx_paging
    })
  },
  mounted() {
    this.getList()
    this.getTxList()
  },
  methods: {
    ...mapActions(['getChanLists', 'getTxLists']),
    getList(limit = 10, offset = 0) {
      let params = {
        offset,
        limit,
        userId: this.userId,
        chan_id: this.chainId
      }
      this.getChanLists(params)
    },
    handleSizeOrPageChange(data) {
      const { offset, limit } = data
      this.getList(limit, offset * limit)
    },
    getTxList(limit = 10, offset = 0) {
      let params = {
        offset,
        limit,
        userId: this.userId
      }
      this.getTxLists(params)
    },
    handleTxSizeOrPageChange(data) {
      const { offset, limit } = data
      this.getTxList(limit, offset * limit)
    },
    createdChannel() {
      this.$refs.createChannel.handleOpen()
    },
    joinChannel() {
      this.$refs.joinChannel.handleOpen()
    },
    exitChannel(row) {
      this.$refs.exitChannel.handleOpen(row.chanName)
    },
    formatTime(row) {
      return this.$utils.dateFormat('YYYY-mm-dd HH:MM', row.createAt)
    },
    //进入通道
    goChannel(row) {
      localStorage.setItem('cbaas_expansion_channel_info', JSON.stringify(row))
      this.$router.push({
        name: 'functionDemo'
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';
.expansion-channel-wrapper {
  @include adaptation(
    (
      --expansion-channel-wrapper-detail-section-padding: 4px 16px 0,
      --expansion-channel-wrapper-detail-section-content-padding: 4px 0 0,
      --expansion-channel-wrapper-divider-margin: 0 0 20px,
      --expansion-channel-wrapper-unavailable-height: 148px,
      --expansion-channel-wrapper-channel-table-unavailable-height: 156px,
      --expansion-channel-wrapper-channel-table-margin-top: 16px,
      --expansion-channel-wrapper-tx-table-unavailable-height: 73px
    )
  );
  --expansion-channel-wrapper-channel-table-min-height: calc(
    (var(--base-main-router-body-avaliable-height) - var(--expansion-channel-wrapper-unavailable-height)) / 2 -
      var(--expansion-channel-wrapper-channel-table-unavailable-height)
  );
  --expansion-channel-wrapper-tx-table-min-height: calc(
    (var(--base-main-router-body-avaliable-height) - var(--expansion-channel-wrapper-unavailable-height)) / 2 -
      var(--expansion-channel-wrapper-tx-table-unavailable-height)
  );
  .cbaas-detail-section /deep/ {
    padding: var(--expansion-channel-wrapper-detail-section-padding);
    .content {
      padding: var(--expansion-channel-wrapper-detail-section-content-padding);
    }
  }

  .normal-table-wrap {
    height: 100%;
    min-height: var(--expansion-channel-wrapper-channel-table-min-height);

    &.channel-table {
      margin-top: var(--expansion-channel-wrapper-channel-table-margin-top);
    }

    /deep/ {
      .el-empty {
        height: 100%;
        min-height: var(--expansion-channel-wrapper-channel-table-min-height);
      }

      .normal-table {
        height: 100%;
        min-height: var(--expansion-channel-wrapper-channel-table-min-height);
      }
    }
  }

  .tx-table.normal-table-wrap {
    height: 100%;
    min-height: var(--expansion-channel-wrapper-tx-table-min-height);

    /deep/ {
      .el-empty {
        height: 100%;
        min-height: var(--expansion-channel-wrapper-tx-table-min-height);
      }

      .normal-table {
        height: 100%;
        min-height: var(--expansion-channel-wrapper-tx-table-min-height);
      }
    }
  }

  .el-divider {
    margin: var(--expansion-channel-wrapper-divider-margin);
  }
}
</style>
